import { render, staticRenderFns } from "./top-info.vue?vue&type=template&id=55b3cbbe"
import script from "./top-info.vue?vue&type=script&lang=js"
export * from "./top-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports